export const MENU_ID = {
	DASHBOARDS: 'dash',
	DASHBOARDS_VIEW_ALL: 'dash-view',
	FILTERS: 'filt',
	FILTERS_SEARCH: 'filt-search',
	FILTERS_VIEW_ALL: 'filt-view-all',
	FILTERS_VIEW_ALL_STARRED: 'filt-view-starred',
	PLANS: 'plan',
	PLANS_VIEW_ALL: 'plan-view-all',
	PROJECTS: 'proj',
	PROJECTS_VIEW_ALL: 'proj-view-all',
	TEAMS: 'team',
	YOUR_WORK: 'yrwk',
} as const;

// The entity types are used to uniquely identify an entity instance.
// The entity's id should be in the URL
export const ENTITY_ID = {
	BOARD: (id: string) => `boar_${id}`,
	FILTER: (id: string) => `filt_${id}`,
	PROJECT: (id: string) => `proj_${id}`,
} as const;
